import { render, staticRenderFns } from "./FUmkmObjectMain.vue?vue&type=template&id=2f5ef83c&scoped=true"
import script from "./FUmkmObjectMain.vue?vue&type=script&lang=js"
export * from "./FUmkmObjectMain.vue?vue&type=script&lang=js"
import style0 from "./FUmkmObjectMain.vue?vue&type=style&index=0&id=2f5ef83c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ef83c",
  null
  
)

export default component.exports